import { useOnboardingNewHomeTakeoverEnabled } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingNewHomeTakeover';

type OnboardingTakeoverType = 'v1'; /* | 'v2' | … */

/**
 * Hook to determine which onboarding takeover will be displayed.
 *
 * @returns The type of onboarding takeover, or `null` if no takeover.
 */
export function useOnboardingTakeoverType(): OnboardingTakeoverType | null {
	const { isEnabled: isNewHomeTakeoverEnabled, loading: iboNewHomeLoading } =
		useOnboardingNewHomeTakeoverEnabled();

	if (!iboNewHomeLoading && isNewHomeTakeoverEnabled) {
		return 'v1';
	}

	return null;
}
